import {h, Fragment} from "preact"
import ProductCard from "./ProductCard";
import { useAppStateSelector } from "@nosto/preact";
import { useEffect, useState } from "preact/hooks";

export default function Products() {
  const { products, loading } = useAppStateSelector((state) => ({
    products: state.response.products,
    loading: state.loading,
  }));

  const [banners, setBanners] = useState([]);
  const [isNewLayout, setIsNewLayout] = useState(false);

  useEffect(() => {
    // Check for new layout
    if (typeof window !== 'undefined' && window.isNewLayout) {
      setIsNewLayout(true);
    }

    if (window.marketingBanners?.length) {
      const sorted = [...window.marketingBanners].sort((a, b) => {
        const aPos =
          a.collection_entry?.is_landscape
            ? Number(a.collection_entry?.position_banner_landscape || 0)
            : Number(a.collection_entry?.position_banner_normal || 0);
        const bPos =
          b.collection_entry?.is_landscape
            ? Number(b.collection_entry?.position_banner_landscape || 0)
            : Number(b.collection_entry?.position_banner_normal || 0);
        return aPos - bPos;
      });
      setBanners(sorted);
    }
  }, []);

  const renderBannerHTML = (banner) => {
    const {
      image,
      is_landscape,
      text_position,
      banner_heading,
      banner_description,
      banner_cta_text,
      banner_cta_url,
    } = banner.collection_entry;

    if (is_landscape) {
      return `
        <div class="marketing-banner landscape">
          <div class="banner-image">
            <img src="${image}" alt="${banner_heading || ''}" />
          </div>
          <div class="banner-content">
            <div class="banner-heading">
              ${banner_heading ? `<h2 class="banner-heading">${banner_heading}</h2>` : ""}
            </div>
            <div class="banner-landscape-info">
              ${banner_description ? `<p class="banner-description">${banner_description}</p>` : ""}
              ${
                banner_cta_text
                  ? `<a href="${banner_cta_url}" class="banner-button">${banner_cta_text}</a>`
                  : ""
              }
            </div>
          </div>
        </div>
      `;
    } else {
      return `
        <div class="marketing-banner normal text-${text_position?.toLowerCase() || "center"}">
          <div class="banner-image">
            <img src="${image}" alt="${banner_heading || ''}" />
          </div>
          <div class="banner-overlay">
            <div class="banner-heading">
              ${banner_heading ? `<h2 class="banner-heading">${banner_heading}</h2>` : ""}
            </div>
            ${
              banner_cta_text
                ? `<a href="${banner_cta_url}" class="banner-button">${banner_cta_text}</a>`
                : ""
            }
          </div>
        </div>
      `;
    }
  };

  // Dynamic grid class based on layout
  const gridClass = isNewLayout
    ? "grid product-grid search-product-grid new-layout"
    : "grid product-grid search-product-grid grid--2-col-tablet-down grid--3-col-desktop";

  return (
    <div
      class={gridClass}
      style={loading ? "opacity: 0.3;" : ""}
    >
      {products.hits.map((hit, index) => {
        const bannerToInsert = banners.find((b) => {
          const entry = b.collection_entry;
          const bannerPosition = entry.is_landscape
            ? Number(entry.position_banner_landscape)
            : Number(entry.position_banner_normal);

          return bannerPosition === index;
        });

        return (
          <>
            {bannerToInsert && (
              <div
                class={`grid__item marketing-banner-item ${
                  bannerToInsert.collection_entry.is_landscape
                    ? "landscape"
                    : `normal text-${bannerToInsert.collection_entry.text_position?.toLowerCase() || "center"}`
                }`}
                dangerouslySetInnerHTML={{
                  __html: renderBannerHTML(bannerToInsert),
                }}
              />
            )}
            <ProductCard
              className="grid__item"
              product={hit}
              key={hit.productId || index}
            />
          </>
        );
      })}
    </div>
  );
}